import { render, staticRenderFns } from "./PhotoDialog.vue?vue&type=template&id=eb31779e&lang=pug"
import script from "./PhotoDialog.vue?vue&type=script&lang=js"
export * from "./PhotoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports